import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import CryWCloneHero from "./CryWCloneHero";
import UseExistingWallet from "./UseExistingWallet";
import RequirementAnalysis from "./RequirementAnalysis";
import LaunchYourW from "./LaunchYourW";
import WhyChoose from "../NFT Wallet/WhyChoose";
import TrustWallet from "./TrustWallet";

function CryptoWalletClone() {
  return (
    <>
      <Header />
      <CryWCloneHero />
      <LaunchYourW />
      <UseExistingWallet />
      <TrustWallet />
      <RequirementAnalysis />
      <WhyChoose />
      <Footer />
    </>
  );
}

export default CryptoWalletClone;
